import { Box, Button, Step, StepLabel, Stepper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CartReview from './CartReview';
import Address from './Address';
import { RootState } from '../../../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveCartStep, setCartList, setSelectedDeliveryAddress } from '../../../Redux/Reducers/globalSlice';
import OrderReview from './OrderReview';
import { AddressInterface } from '../../../types/Address';
import OrderCompleted from './OrderCompleted';
import { ApiGetAddress, ApiGetCartList } from '../../../Core/Apicall';
import { toast } from 'react-toastify';
import { ArrowForward, ShoppingBag, ShoppingBagOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function Cartlist() {
  const steps = ['Cart', "Address", "Review", "Ordered"]
  const { activeCartStep, cartlist, userDetails } = useSelector((state: RootState) => state.global)
  const [selectedAddress, setSelectedAddress] = useState<any>()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // const [activeStep, setActiveStep] = useState<number>(0)
  const RenderStep = () => {
    switch (activeCartStep) {
      case 0:
        return <CartReview />;

      case 1:
        return <Address />;

      case 2:
        return <OrderReview />;

      case 3:
        return <OrderCompleted />;

      //   default:
      //     return <ProductDetails />;
    }
  };

  const GetCartlist = async () => {
    try {
      const res = await ApiGetCartList()
      if (res?.status) {
        dispatch(setCartList(res?.data))
      }
    } catch (error: any) {
      console.log("Error", error)
      toast.error(error?.message || "Something went wrong");
    }
  }


  useEffect(() => {
    GetCartlist()
  }, [])


  return (cartlist?.items && cartlist?.items?.length > 0) ? (

    <Box className='p-lg-3 p-xl-4 p-2'>
      <Box className='stepper'>
        <Stepper
          className='gap-4 gap-md-5 mx-auto p-0 fs-20 position-relative'
          activeStep={activeCartStep}
          alternativeLabel
          sx={{
            width: { xs: "100%", md: "100%", xl: "50%" },
            "& .MuiStepLabel-label.Mui-active": {
              color: "var(--primary-color) !important",
              fontWeight: 600,
            },

            // Completed label
            "& .MuiStepLabel-label.Mui-completed": {
              color: "var( --primary-dark-color) !important",
              fontWeight: 600,
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={label} className='pointer'>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box className='mt-4 mt-md-0'>
        {RenderStep()}
      </Box>
    </Box>
  ) : (
    <Box className='p-lg-3 p-xl-4 p-2  h-100 d-flex align-items-center justify-content-center flex-column align-items-center'>
      <Typography variant='h3' className='text-center fw-bold'>Your Cart is Empty</Typography>
      <Typography variant='body2' className='text-center text-grey'>Looks like you haven't added any products to your cart yet. <br /> Explore our products and find what you need!</Typography>
      <Button className='btn-main px-4 py-2 mt-3' onClick={() => { navigate(`/${userDetails?.role}/products`) }}><ShoppingBagOutlined />&nbsp; Browse Products &nbsp;<ArrowForward /></Button>
    </Box>
  )
}

export default Cartlist
